const apiConfig = {
    "baseUrl": "https://reports.tibura.services:3095",
   // "baseUrl": "http://localhost:3092",
    "appName": "Identti Front End",
    "apiKey": "apiKey",
    "secrect": "secrect",
}

export default apiConfig;